import { TariffContext } from 'Services/ProductManagement/Features/Tariff/Context/tariffContext'
import {
  fetchSingleTariff,
  type UpdateTariffRequestData,
  updateSingleTariff
} from 'Services/ProductManagement/Features/Tariff/tariffSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { useContext, useEffect } from 'react'

function useSingleTariff(id: string | undefined) {
  const dispatch = useAppDispatch()
  const { setSelectedTariffId } = useContext(TariffContext)
  const { singleTariff, singleLoading, submitLoading } = useTypedSelector(state => state.tariff)

  useEffect(() => {
    if (!id) return
    dispatch(fetchSingleTariff({ id })).then(() => setSelectedTariffId(id))
  }, [id])

  const updateTariff = (id: string, data: UpdateTariffRequestData) => {
    return dispatch(updateSingleTariff({ id, ...data }))
  }

  return {
    singleTariff,
    singleLoading,
    submitLoading,
    updateTariff
  }
}

export default useSingleTariff
